// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__WQjKq","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__11z2-"};